module.exports = __webpack_public_path__ + "static/media/washington_sauna.3f3c107d.jpg";